import * as React from 'react';

import { cn } from '@/lib/utils';

const TONE_CLASSES = {
	live: 'bg-success',
	warning: 'bg-warning',
	error: 'bg-destructive',
	info: 'bg-primary',
	muted: 'bg-muted-foreground'
};

/**
 * Pulsing dot used for "Live", "In Progress", "Pending" channel/feature states.
 * The outer ring fades in and out via the `ping-once` animation.
 */
const StatusIndicator = React.forwardRef(({ className, tone = 'live', label, ...props }, ref) => (
	<span ref={ref} className={cn('relative inline-flex items-center gap-2 text-xs font-medium text-foreground', className)} {...props}>
		<span className="relative inline-flex h-2.5 w-2.5">
			<span className={cn('absolute inset-0 rounded-full opacity-70 animate-ping-once', TONE_CLASSES[tone])} />
			<span className={cn('relative inline-flex h-2.5 w-2.5 rounded-full', TONE_CLASSES[tone])} />
		</span>
		{label ? <span>{label}</span> : null}
	</span>
));
StatusIndicator.displayName = 'StatusIndicator';

export { StatusIndicator };
